import {toast} from "react-toastify";

export default function useToastify() {
  const dismissAll = () =>  toast.dismiss();

  const notifyError = (msg) => {
    console.log("useToastify.js: notifyError: msg: ", msg);
    dismissAll();
    toast.error(msg);
  }

  const notifySuccess = (msg) => {
    dismissAll();
    toast.success(msg);
  }

  return {
    dismissAll,
    notifyError,
    notifySuccess,
  }
}